<!-- 支付宝支付 -->
<template>
  <div class="zhifu"></div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return { datadorm: '' }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getalopay()
  },
  methods: {
    getalopay() {
      this.datadorm = JSON.parse(localStorage.getItem('datadorm'))
      // document.getElementById('html_body').innerHTML = res;
      // const div = document.createElement('div') // 创建div
      // div.innerHTML = this.datadorm // 将返回的form 放入div
      // document.body.appendChild(div)
      // document.forms[0].submit()
      document.querySelector('div').innerHTML = this.datadorm
      document.forms[0].submit()
    },
  },
}
</script>

